import React, { useState, useEffect } from "react";
import loaderIcon from "assets/img/loader.gif";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import {
  FormControl,
  TextField,
  IconButton,
  Icon,
  Tooltip,
} from "@material-ui/core";
import green from "@material-ui/core/colors/green";
import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
// import { useDispatch, useSelector } from "react-redux";
import ReactTable from "react-table";

const formStyle = {
  minWidth: "100%",
  margin: "0 1.2rem 1.2rem 0",
};
function ManageAdmin(props) {
  // const dispatch = useDispatch();
  // const { adminData, loading } = useSelector((state) => state.admin);
  const { classes } = props;
  const [state, setState] = useState({
    search: "",
  });

  const handleChange = (e) => {
    const { value } = e.target;
    setState({ ...state, search: value });
  };

  const goToAddAdmin = () => {};

  const getColumns = () => {
    let column = [
      {
        Header: <strong>Admin Name</strong>,
        sortable: false,
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        Cell: ({ original }) => {
          const { admin_name } = original;
          return <span>{admin_name ? admin_name : "N/A"}</span>;
        },
      },
      {
        Header: <strong>Email</strong>,
        sortable: false,
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        Cell: ({ original }) => {
          const { email } = original;
          return <span>{email ? email : "N/A"}</span>;
        },
      },
      {
        Header: <strong>Mobile No.</strong>,
        sortable: false,
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        Cell: ({ original }) => {
          const { mobile } = original;
          return <span>{mobile ? mobile : "N/A"}</span>;
        },
      },
      {
        Header: <strong>Admin Role</strong>,
        sortable: false,
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        Cell: ({ original }) => {
          const { role } = original;
          return <span>{role ? role : "N/A"}</span>;
        },
      },
      {
        Header: <strong>Actions</strong>,
        sortable: false,
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        Cell: ({ original }) => {
          return (
            <div className="actions-center">
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={goToAddAdmin}
                >
                  <Icon>edit_icon</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ];
    return column;
  };
 return null
  // return (
  //   <div>
  //     {loading ? (
  //       <div className="loader_icon">
  //         <img src={loaderIcon} />
  //       </div>
  //     ) : (
  //       <div>
  //         <GridContainer>
  //           <GridItem xs={12}>
  //             <Card>
  //               <CardBody>
  //                 <FormControl
  //                   className={classes.formControl}
  //                   style={formStyle}
  //                 >
  //                   <TextField
  //                     id="standard-search"
  //                     label="Search Admin by name"
  //                     name="search"
  //                     type="search"
  //                     fullWidth
  //                     value={state.search}
  //                     onChange={handleChange}
  //                     margin="normal"
  //                   />
  //                   <ReactTable
  //                     data={adminData}
  //                     loading={loading}
  //                     columns={getColumns()}
  //                     defaultPageSize={25}
  //                     pageSizeOptions={[25, 50, 100]}
  //                     showPaginationBottom={true}
  //                     minRows={5}
  //                     noDataText="No Admin found"
  //                     //   onPageChange={pageChange}
  //                     //   onPageSizeChange={pageChange}
  //                     //   getTrProps={(state, rowInfo, column, instance) => {
  //                     //     return {
  //                     //       onClick: (e, handleOriginal) => {
  //                     //         if (rowInfo) {
  //                     //           // this.editCategoryFunc(rowInfo.original);
  //                     //         }
  //                     //       },
  //                     //       style: {
  //                     //         textAlign: "center",
  //                     //         cursor: "pointer",
  //                     //       },
  //                     //     };
  //                     //   }}
  //                     //   getTheadThProps={(state, rowInfo, column, instance) => {
  //                     //     return {
  //                     //       style: {
  //                     //         marginBottom: "13px",
  //                     //       },
  //                     //     };
  //                     //   }}
  //                   />
  //                 </FormControl>
  //               </CardBody>
  //             </Card>
  //           </GridItem>
  //         </GridContainer>
  //       </div>
  //     )}
  //   </div>
  // );
}

export default withStyles(extendedTablesStyle)(ManageAdmin);



// WEBPACK FOOTER //
// ./src/views/ISEAS/AdminManagement/index.js